import api from '../../plugins/api';

// Повторный запуск проверок владельца (п.6, PUT /owner/restart).
// Нужен после хука OWNER_ON_REVISION: менеджер обновляет данные владельца
// в ЦОН и заново запускает проверку.
const ffinRestartOwner = ({ appealId }) => {
  return api.put('/api/bank/ffin/owner/restart', { appealId });
};

export default ffinRestartOwner;
